// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5460a33d","451":"4bf75ba9","453":"c236b0ab","667":"b8bcf2b8"}[chunkId] + ".chunk.js";
};